<script>
    import {getUser} from '../auth-store';
    import {url} from "@sveltech/routify";
    import {goto, isActive} from '@sveltech/routify';

    let user = getUser();

    if (user) {
        $goto('/app/campaigns');
    } else {
        if (!$isActive('/login') && !$isActive('/password')) {
            $goto('/login');
        }
    }

</script>

<div class="logo-container">
    <a href={$url('/login')}>
        <img src="/images/imin-logo.jpg" alt="I'M IN logo" width="40">
    </a>
</div>
<slot scoped={{user}}/>

<style>
    .logo-container {
        background-color: white;
        padding: 10px;
        margin-bottom: 20px;
    }
</style>